import React from 'react';
import { PageSection, FormBoolean } from 'adc-ui-components';
import { withFormik, Field } from 'formik';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import Card from '../../../components/Card';
import CardGroup from '../../../components/CardGroup';
import OrderDetails from '../../../components/OrderDetails';
import DeviceUpdateDetails from '../../../components/DeviceUpdateDetails';
import HowToReturnOldEquipment from '../../../components/HowToReturnOldEquipment';
import BooleanField from '../../../components/form-elements/BooleanField';
import PlayIcon from '../../../components/svgs/Play';
import { RequiredFactory } from '../../../helpers/validation/required';

import { joinClass } from '../../../helpers/component';
import { getReviewDetails } from '../../../helpers/swaps';
import { SWAPS_NEW, withQuery } from '../../../helpers/routes';

const vRequired = RequiredFactory();
const Review = ({
  handleSubmit,
  submitLoading,
  devices,
  account,
  macaroon,
  errors = {},
}) => (
  <PageSection>
    <h1 className="heading2">Review your device update details</h1>

    <CardGroup className="mb12">
      <Card>
        <h3>{'We\'ll ship the new equipment to you'}</h3>
      </Card>
      <Card>
        <div className="ma-grid align-items-center">
          <div className="ma-grid__col ma-grid__col--1of2 text-center">
            <img width="231" height="117" src="https://static.cimcontent.net/common-web-assets/svg/order-hub/package2.svg" alt="package" />
          </div>
          <div className="ma-grid__col ma-grid__col--1of2">
            <ul className="mb0">
              <li className="mb12">Your equipment should arrive within 3-5 days</li>
              <li className="mb12">Set up new equipment at your convenience</li>
              <li type="none">
                <a
                  href="https://www.xfinity.com/support/articles/how-to-activate-your-self-install-devices"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View Step-by-Step Instructions
                  <PlayIcon className="svg-icon--14 ml3" />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </Card>
    </CardGroup>

    <OrderDetails
      title="Delivery information"
      details={getReviewDetails(account, macaroon)}
    />
    <DeviceUpdateDetails
      devices={devices}
      action={<Link to={withQuery(SWAPS_NEW)}>Edit</Link>}
    />
    <HowToReturnOldEquipment />

    <form
      onSubmit={handleSubmit}
      noValidate
    >
      <div className="mb12 clearfix">
        <Card className={joinClass('mb12', errors.terms && 'card--error')}>
          <FormBoolean
            inputId="terms"
            label="By placing this order you understand and acknowledge that you are responsible for returning your existing equipment. You will be billed a monthly charge if your existing equipment is not returned within 30 days of activating your equipment."
          >
            <Field
              id="terms"
              name="terms"
              type="checkbox"
              component={BooleanField}
              validate={vRequired(true)}
              suppressError
            />
          </FormBoolean>
        </Card>

        {errors.terms && <p className="form-control__error pt0 mb0">Please check the box above to continue</p>}
      </div>

      <div className="action action--right">
        <div className="action__item">
          <button
            type="submit"
            disabled={submitLoading}
            className={joinClass('button button--primary', submitLoading && 'is-loading')}
          >
            Submit Order
          </button>
        </div>
        <div className="action__item">
          <Link className="button" to={withQuery(SWAPS_NEW)}>Back</Link>
        </div>
      </div>
    </form>
  </PageSection>
);

const SwapReview = withFormik({
  mapPropsToValues: () => ({ terms: false }),
  handleSubmit: (values, { props }) => {
    props.onReviewSubmit();
  },
  displayName: 'SwapReview',
})(Review);

const mapStateToProps = ({
  swapEligibility: { submitLoading },
  account: { data: accountData },
  auth: { macaroon },
}) => ({
  submitLoading,
  macaroon,
  account: accountData,
});

export default connect(mapStateToProps)(SwapReview);
